import React from "react"

import {FormattedMessage} from "@irati/utils/lang"
import IconText from "../../IconText"
import mainTheme from "../../global/theme"
import {Body} from "../../Typography"
import {CharacterCountDownVariants} from "./enums"
import {IconTypes} from "@irati/ui/src/Icon"

interface Props {
  maxLength?: number
  value?: string
  variant?: CharacterCountDownVariants
}

const CharacterCountDown: React.FC<Props> = (props) => {
  const {maxLength = 0, value = "", variant = "default"} = props
  const calculateRemainingCharacters = () => {
    return value ? maxLength! - value.length : maxLength
  }
  const inputCount = calculateRemainingCharacters()
  const hasError = typeof inputCount !== "undefined" && inputCount < 0

  if (variant === CharacterCountDownVariants.SHORT) {
    return (
      <Body small color={hasError ? mainTheme.colors.error : mainTheme.colors.greys.medium}>
        {`${value!.length}/${maxLength}`}
      </Body>
    )
  }
  return (
    <IconText icon={hasError ? IconTypes.circleAlertFill : IconTypes.info} hasError={hasError}>
      <FormattedMessage id="platform.characterCountDown.charactersRemaining" values={{inputCount}} />
    </IconText>
  )
}
export default CharacterCountDown
